export const CONTACT_US_API_ROUTES = {
    CONTACT_US : "home/contactus "
}